import { BaseRequest } from './BaseRequest';

export class EditPhoneNumberWebhookRequest extends BaseRequest {
    PhoneNumberWebhookUrl: string;
}